import { render, staticRenderFns } from "./indexAdd.vue?vue&type=template&id=6cf663e0&scoped=true&"
import script from "./indexAdd.vue?vue&type=script&lang=js&"
export * from "./indexAdd.vue?vue&type=script&lang=js&"
import style0 from "./indexAdd.vue?vue&type=style&index=0&id=6cf663e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf663e0",
  null
  
)

export default component.exports